module.exports = __webpack_public_path__ + "static/media/Proxima-Nova-Regular.44142ecb.ttf";